import React from "react";
import { formatBook } from "../../../utils/formatOdds";

/**
 * BetTableMuf – Muflis Teenpatti (casino/teenmuf), reference markup:
 *   .teen1daycasino-container > .teen1dayleft | .teen1daycenter | .teen1dayright
 *     .casino-box-row(title Player A/B) + .row.row5 > 3 × .col-12.col-md-4 (Winner, Top 9, M Baccarat)
 *       .casino-box-row > .casino-nation-name > b + .casino-bl-box > .back.casino-bl-box-item[.suspended[.lock-top]]
 *         (span.casino-box-odd + span.book-red|book-green)
 * Top 9 shows the player letter instead of the odds. Suspended = gstatus !== "OPEN" (reference); a
 * suspended cell with a book gets .lock-top (tenexch: padlock at the top only with a liability).
 */
export default function BetTableMuf({ data = [], onBetClick, exposures = {}, myBets = [] }) {
  const findItem = (nat) => data.find((item) => item.nat === nat) || {};

  const getExposure = (selection) => {
    if (!selection) return 0;
    const key = [selection, selection.toLowerCase().trim(), selection.trim()]
      .find((k) => k && exposures[k] !== undefined && exposures[k] !== 0);
    if (key != null) return parseFloat(exposures[key]) || 0;
    const match = myBets.find((b) => {
      const sel = (b.matchedBet || b.selection || b.player_name || "").toLowerCase().trim();
      return sel === selection.toLowerCase().trim();
    });
    if (match && match.exposer !== undefined && match.exposer !== null && match.exposer !== 0)
      return parseFloat(match.exposer) || 0;
    return 0;
  };

  const isSuspended = (item) => String(item?.gstatus || "").toUpperCase() !== "OPEN" || !item?.b;

  const renderCell = (item, label, nat, displayValue) => {
    const suspended = isSuspended(item);
    const exposure = getExposure(nat);
    return (
      <div className="col-12 col-md-4">
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b>{label}</b>
          </div>{" "}
          <div className="casino-bl-box">
            <div
              className={`back casino-bl-box-item${suspended ? (exposure ? " suspended lock-top" : " suspended") : ""}`}
              onClick={() =>
                !suspended && item?.b && onBetClick && onBetClick(item.b, label, "back", { ...item, nat })
              }
            >
              <span className="casino-box-odd">{displayValue ?? item?.b ?? 0}</span>{" "}
              <span className={exposure > 0 ? "book-green" : "book-red"}>{formatBook(exposure)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const side = (player) => (
    <>
      <div className="casino-box-row">
        <div className="casino-nation-name no-border casino-bl-box-title">
          <div className={`player${player.toLowerCase()} text-left`}>Player {player}</div>
        </div>
      </div>{" "}
      <div className="row row5">
        {renderCell(findItem(`Player ${player}`), "Winner", `Player ${player}`)}{" "}
        {renderCell(findItem(`Top 9 ${player}`), "Top 9", `Top 9 ${player}`, player)}{" "}
        {renderCell(findItem(`M Baccarat ${player}`), `M Baccarat ${player}`, `M Baccarat ${player}`)}
      </div>
    </>
  );

  return (
    <div className="teen1daycasino-container">
      <div className="teen1dayleft">{side("A")}</div>{" "}
      <div className="teen1daycenter" />{" "}
      <div className="teen1dayright">{side("B")}</div>
    </div>
  );
}
